<section class="vehiculos-carousel container-xl">
    <h2 class="vehiculos-titulo text-center mb-4">
        {{ 'fe_lp_autos_subtitle_3' | translate }}
    </h2>

    <div class="swiper vehiculos-swiper position-relative">
        <!-- Flechas personalizadas -->
        <div class="vehiculo-button-prev custom-arrow">
            <img [src]="'images/arrow-left.svg' | cdn" alt="Anterior" />
        </div>
        <div class="vehiculo-button-next custom-arrow">
            <img [src]="'images/arrow-right.svg' | cdn" alt="Siguiente" />
        </div>

        <!-- Slides -->
        <div class="swiper-wrapper">
            <div *ngFor="let auto of vehiculos" class="swiper-slide">
                <div class="vehiculo-card text-center p-4">
                    <img
                        [src]="auto.imagen | cdn"
                        [alt]="auto.modelo"
                        class="vehiculo-img mb-3"
                    />

                    <h4 class="vehiculo-tipo">{{ auto.tipo | translate }}</h4>
                    <p class="vehiculo-modelo">{{ auto.modelo | translate }}</p>

                    <div
                        class="vehiculo-info d-flex justify-content-center gap-4 mt-3 mb-4"
                    >
                        <span class="d-flex align-items-center">
                            <img
                                [src]="'images/transmision.svg' | cdn"
                                alt="Transmisión"
                                class="me-1"
                            />
                            {{ auto.transmision | translate }}
                        </span>
                        <span class="d-flex align-items-center">
                            <img
                                [src]="'images/personas.svg' | cdn"
                                alt="Pasajeros"
                                class="me-1"
                            />
                            {{ auto.pasajeros }}
                        </span>
                        <span class="d-flex align-items-center">
                            <img
                                [src]="'images/maleta.svg' | cdn"
                                alt="Maletas"
                                class="me-1"
                            />
                            {{ auto.maletas }}
                        </span>
                    </div>

                    <a
                        [routerLink]="[]"
                        fragment="sectionForm"
                        class="btn-unete"
                        >{{ 'fe_lp_renta_flexible_cta_join' | translate }}</a
                    >
                </div>
            </div>
        </div>
    </div>

    <!-- Texto descriptivo -->
    <div class="vehiculos-descripcion mt-5">
        <ul>
            <li>
                <strong>{{ 'fe_lp_autos_benefit_title_1' | translate }}</strong>
                {{ 'fe_lp_autos_benefit_description_1' | translate }}
            </li>
            <li>
                <strong>{{ 'fe_lp_autos_benefit_title_2' | translate }}</strong>
                {{ 'fe_lp_autos_benefit_description_2' | translate }}
            </li>
            <li>
                <strong>{{ 'fe_lp_autos_benefit_title_3' | translate }}</strong>
                {{ 'fe_lp_autos_benefit_description_3' | translate }}
            </li>
            <li>
                <strong>{{ 'fe_lp_autos_benefit_title_4' | translate }}</strong>
                {{ 'fe_lp_autos_benefit_description_4' | translate }}
            </li>
        </ul>
    </div>
</section>
